<template>
    <div>
        <div class="banner notice-bn">
            <img src="@/assets/images/banner5.png" alt="">
            <h2 class="title">Notice｜來認識下</h2>
        </div>
        <div class="wrap">
            <section id="tabs-block" class="section">
                <ul class="text-center">
                    <li><a href="javascript:;">
                        <div class="name">承租<br>須知</div>
                        <p>contract</p>
                    </a></li>
                </ul>
            </section>
            <section id="notice" class="section intro-section">
                <div class="intro">
                    <h3>訂房須知</h3>
                    <div class="get_content">
                        {{ the_content }}
                    </div>
                    <!-- <ol>
                        <li>入住前須詳閱相關住宿規定，以維護您與其它賓客的權益</li>
                        <li>入住時間為下午3點至晚間22點30分</li>
                        <li>退房時間為上午11點，延後退房每小時收取新台幣200元，最多延長1-3小時(視當日住房情況)</li>
                        <li>無法攜帶寵物入住</li>
                        <li>請依櫃台人員指示停放指定停車場『中央公園南側(河南路)停車場』，若非停至指定停車場將無法補助停車費</li>
                        <li>辦理Check in時需出示證件確認是本人入住；未滿18歲無法登記入住，需有監護人陪同或證明</li>
                        <li>房卡若不慎遺失或損毀，每張收取新台幣200元</li>
                        <li>請依照訂房人數入住，若加人或加床請向櫃檯先行登記</li>
                        <li>全館禁菸、賭博、吸毒等違法行為，若違法會請執法單位查辦</li>
                        <li>請愛惜使用客房內寢具家飾及設備等物品，請勿破壞或私自拿取房內設備及物品</li>
                        <li>房內禁止使用非本旅宿配置之電器用品，如：瓦斯、電毯、電暖爐等高耗電之電器用品</li>
                        <li>櫃台服務時間是07:00-10:00，如住宿房客超過10:00須要詢問相關館內問題，可於服務時間告知櫃台人員，我們會安排人員等候配合或10:00後如有問題，可以在FB或line@私訊給我們，我們會在第二天上班時間用最快速度回覆您</li>
                        <li>因應防疫措施若為旅客「具有風險」,將有權視情況取消訂房，且退還訂金。</li>
                        <li>本飯店因應政府措施，並非防疫旅館，無法接待外國商務旅客，敬請見諒。</li>
                        <li>若因不可抗拒因素無法入住，請於住宿７日前告知，可辦理訂房延期３個月內（為保障其他訂房客人權益，限延期一次，之後不予保留並全額扣款）</li>
                        <li>退訂規則以住宿日期為當日起開始計算：<br>
                            預訂住宿日當天取消訂房者，恕不退還訂金<br>
                            住宿日前14日內取消訂房者，退還訂金100%<br>
                            住宿預訂住宿日前1日內取消訂房者，退還訂金20%<br>
                            預訂住宿日前2-3日內取消訂房者，退還訂金30%<br>
                            預訂住宿日前4-6日內取消訂房者，退還訂金40%<br>
                            預訂住宿日前7-9日內取消訂房者，退還訂金50%<br>
                            預訂住宿日前10-13日內取消訂房者，退還訂金70%<br>
                            預訂當日如遇颱風或地震等不可抗力因素(以所在縣市政府發布為準)，房費可全額退還或保留3個月</li>
                    </ol> -->
                </div>
            </section>
            <section class="section_file">
                <div class="block_img">
                    <img v-for="(the_img, idx) in the_imgs" :key="idx" :src="the_img" alt="">
                </div>
                <div class="btn-block text-center">
                    <a v-for="(the_pdf, idx) in the_pdfs" :key="idx" :href="the_pdf" target="_blank" class="btn btn-br">下載列印</a>
                </div>
            </section>
        </div>
    </div>
</template>

<script>

export default {
    name: 'notice',
    data () {
        return {
            the_content:'',
            the_imgs: [],
            the_pdfs: []
        }
    },
    beforeMount: function () {
        const formData = new FormData();
        formData.append('CMD', 'NoticeList');
        this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, formData)
        .then(response => {
            // console.log(response);
            if (response.data.result == false) {
                console.log('NoticeList: Server Error');
            }else {
                const get_content = response.data.content;
                const get_imgs = response.data.images_url;
                const get_pdfs = response.data.pdf_url;
                this.the_content = get_content;
                this.the_imgs = JSON.parse(get_imgs);
                this.the_pdfs = get_pdfs;
            }
        })
        .catch(error => {
            console.log(error);
        })
    }
};
</script>

<style>
.section_file {
    margin-bottom: 20px;
}
.get_content {
    white-space: pre-line;
    margin-bottom: 5px;
}
.block_img{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin: 10px 0;
}
.block_img img{
    padding: 5px;
    width: 250px;
}
@media (max-width: 820px) {
    .block_img img{
        width: 50%;
    }
}
@media (max-width: 576px) {
    .block_img img{
        width: 100%;
    }
}
</style>
